/* MARU MORI :: cart drawer
   The other colourways in a swipeable row, size preset to the size in the bag. */
(function () {
  if (window.mmCart) return;
  window.mmCart = true;

  var WAIST = { S: '28', M: '31', L: '34', XL: '37', '2XL': '40' };
  var ALIAS = { 'black-evening-boxer-3-pack': 'the-evening-boxer-black' };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Cart drawer: the other colourways ---------------- */

  var colourwayData = null;
  function colourways() {
    if (colourwayData) return colourwayData;
    var el = document.getElementById('mmColourways');
    try {
      colourwayData = el ? JSON.parse(el.textContent) : [];
    } catch (e) {
      colourwayData = [];
    }
    return colourwayData;
  }

  function cartRow() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    var footer = inner.querySelector('.drawer__footer');
    var items = inner.querySelectorAll('.cart-item');
    var existing = inner.querySelector('.mm-also');
    if (!items.length || !footer) {
      if (existing) existing.remove();
      return;
    }
    var data = colourways();
    if (!data.length) return;

    var inCart = {};
    var size = '';
    Array.prototype.forEach.call(items, function (it) {
      var a = it.querySelector('a.cart-item__name') || it.querySelector('a[href*="/products/"]');
      if (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) {
          inCart[m[1]] = true;
          if (ALIAS[m[1]]) inCart[ALIAS[m[1]]] = true;
        }
      }
      Array.prototype.forEach.call(it.querySelectorAll('.product-option dd'), function (dd) {
        var v = dd.textContent.trim();
        if (WAIST[v]) size = v;
      });
    });

    var list = data.filter(function (c) { return !inCart[c.handle]; });
    var sig = list.map(function (c) { return c.handle; }).join(',') + '|' + size;
    if (existing && existing.getAttribute('data-sig') === sig) return;
    if (existing) existing.remove();
    if (!list.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'mm-also';
    wrap.setAttribute('data-sig', sig);
    wrap.innerHTML = '<p class="mm-also__label">You might also like</p><div class="mm-also__track"></div>';
    var track = wrap.querySelector('.mm-also__track');

    list.forEach(function (c) {
      var pre = null;
      c.variants.forEach(function (v) {
        if (v.size === size && v.available) pre = v.id;
      });
      var opts = pre ? '' : '<option value="" selected disabled>Size</option>';
      c.variants.forEach(function (v) {
        opts += '<option value="' + v.id + '"' + (v.id === pre ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' +
          esc(v.size) + (v.available ? '' : ' · sold out') + '</option>';
      });
      var card = document.createElement('div');
      card.className = 'mm-also__card';
      card.innerHTML =
        '<a class="mm-also__img" href="' + esc(c.url) + '">' +
          (c.image ? '<img src="' + esc(c.image) + '" alt="' + esc(c.alt) + '" loading="lazy" width="66" height="88">' : '') +
        '</a>' +
        '<div class="mm-also__body">' +
          '<div><p class="mm-also__name">' + esc(c.name) + '</p><p class="mm-also__price">' + esc(c.price) + '</p></div>' +
          '<div class="mm-also__actions">' +
            '<select aria-label="Size for ' + esc(c.name) + '">' + opts + '</select>' +
            '<button type="button" class="mm-also__add">Add</button>' +
          '</div>' +
          '<p class="mm-also__err" hidden></p>' +
        '</div>';
      track.appendChild(card);
      labelAdd(card);
    });

    footer.parentNode.insertBefore(wrap, footer);
  }

  function labelAdd(card) {
    var sel = card.querySelector('select');
    var btn = card.querySelector('.mm-also__add');
    if (!sel || !btn) return;
    var opt = sel.options[sel.selectedIndex];
    var want = sel.value && opt ? 'Add · ' + opt.textContent.trim() : 'Add';
    if (btn.textContent !== want) btn.textContent = want;
  }

  function addColourway(card) {
    var sel = card.querySelector('select');
    var btn = card.querySelector('.mm-also__add');
    var err = card.querySelector('.mm-also__err');
    if (!sel || !btn) return;
    if (!sel.value) {
      err.textContent = 'Choose a size';
      err.hidden = false;
      sel.focus();
      return;
    }
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    err.hidden = true;
    var cd = document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', sel.value);
    fd.append('quantity', '1');
    if (cd && typeof cd.getSectionsToRender === 'function') {
      fd.append('sections', cd.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
    }
    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) {
          btn.removeAttribute('aria-busy');
          err.textContent = res.description || 'That size is not available.';
          err.hidden = false;
          return;
        }
        if (cd && typeof cd.renderContents === 'function' && res && res.sections) {
          cd.renderContents(res);
        } else {
          window.location.href = '/cart';
        }
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mm-colourways' });
          }
        } catch (e) {}
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        err.textContent = 'Something went wrong. Try again.';
        err.hidden = false;
      });
  }

  function initCart() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(cartRow, 30);
    }).observe(drawer, { childList: true, subtree: true });
    cartRow();

    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('.mm-also select')) {
        var card = e.target.closest('.mm-also__card');
        labelAdd(card);
        var err = card.querySelector('.mm-also__err');
        if (err) err.hidden = true;
      }
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.mm-also__add');
      if (!b) return;
      e.preventDefault();
      addColourway(b.closest('.mm-also__card'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCart);
  } else {
    initCart();
  }
})();